module.exports = __webpack_public_path__ + "img/icon_2.5eda251c.png";